import { useState, useEffect } from "react";
import { useAppSelector } from "../../../context-store";
import CompanyClasses from "../../../landing-pages/Company/company.module.css";
import PagedListModel from "../../../models/common/PagedListModel";
import { SortDirection } from "../../../models/enums/SortDirectionEnum";
import relatedShortlistedProfilesService from "../../../services/company/related-shortlisted-profiles-service";
import toasterUtils from "../../../utils/toaster-utils";
import IdNameModel from "../../../models/common/IdNameModel";
import RelatedProfilesGridComponent from "./RelatedProfilesGridComponent";
import RelatedProfilesSearchInputModel from "../../../models/company/relatedAndShortlistedProfiles/request/RelatedProfilesSearchInputModel";
import RelatedProfilesGridModel from "../../../models/company/relatedAndShortlistedProfiles/response/RelatedProfilesGridModel";
import RelatedProfilesRequestModel from "../../../models/company/relatedAndShortlistedProfiles/request/RelatedProfilesRequestModel";
import modalUtils from "../../../utils/modal-utils";
import { GeneralPoupConfig, ModalSize } from "../../../models/modal-types";
import addProfilesService from "../../../services/company/add-profiles-service";
import RatingDetailsPopUp from "../../candidate/dashboard/RatingDetailsComponent";
import { PagingEnum } from "../../../models/enums/IAIEnum";
import masterDataService from "../../../services/master-data-service";
import { FormControl, InputLabel, MenuItem, Select, Button, Autocomplete, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

interface RelatedProfilesProps {
    cityList: IdNameModel[];
    experienceList: IdNameModel[];
    ratingList: IdNameModel[];
    requirementId: string;
};

const RelatedProfilesComponent = (props: RelatedProfilesProps) => {
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const [relatedProfilesPagedList, setRelatedProfilesPagedList] = useState<PagedListModel<RelatedProfilesGridModel>>();
    const [relatedProfilesList, setRelatedProfilesList] = useState<RelatedProfilesGridModel[]>([]);
    const [refreshRelatedProfiles, setRefreshRelatedProfiles] = useState<number>(2);
    const [totalRatingSearch, setTotalRatingSearch] = useState<number>(0);
    const [citySearch, setCitySearch] = useState<number>(0);
    const [experienceSearch, setExperienceSearch] = useState<number>(0);
    const [page, setPage] = useState<number>(PagingEnum.page);
    const [pageSize, setPageSize] = useState<number>(PagingEnum.pageSize);
    const [sortColumn, setSortColumn] = useState<string>("CandidateName");
    const [sortDirection, setSortDirection] = useState<number>(PagingEnum.sortDirection);
    const [pageSizesList, setPageSizesList] = useState<number[]>([]);

    useEffect(() => {
        loadPageSizes();
        getRelatedProfiles(getSearchFilters(page, pageSize, sortColumn, sortDirection));
    }, []);

    const loadPageSizes = () => {
        masterDataService.loadPageSizesForPaging().then((res) => {
            setPageSizesList(res);
        }).catch((error) => {
            toasterUtils.showError(error);
        });
    };

    const getSearchFilters = (page: number, pageSize: number, sortColumn: string, sortDirection: number) => {
        var inputData: RelatedProfilesSearchInputModel = {
            requirementId: props.requirementId,
            totalRating: totalRatingSearch === 0 ? null : totalRatingSearch,
            cityId: citySearch === 0 ? null : citySearch,
            experienceId: experienceSearch === 0 ? null : experienceSearch,
            page: page,
            pageSize: pageSize,
            sort: sortColumn,
            sortDir: sortDirection
        };
        return inputData;
    };

    const getRelatedProfiles = (inputData: RelatedProfilesSearchInputModel) => {
        setRefreshRelatedProfiles(2);
        if (loggedInUser?.profileId) {
            modalUtils.showLoader();
            relatedShortlistedProfilesService.getRelatedProfilesGrid(inputData).then((res) => {
                modalUtils.closeModal();
                setRelatedProfilesList([]);
                setRelatedProfilesPagedList(res);
                setRelatedProfilesList(res.items);
                setRefreshRelatedProfiles(refreshRelatedProfiles * 5);
            }).catch((error) => {
                modalUtils.closeModal();
                toasterUtils.showError(error);
            });
        }
    };

    const onShortlistProfileHandler = (objShortlistProfile: RelatedProfilesRequestModel) => {
        setRefreshRelatedProfiles(2);
        modalUtils.showLoader();
        relatedShortlistedProfilesService.saveRelatedProfile(objShortlistProfile).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            toasterUtils.showSuccess(res.informationMessages.toString());
            getRelatedProfiles(getSearchFilters(page, pageSize, sortColumn, sortDirection));
        }).catch((error) => {
            setRefreshRelatedProfiles(refreshRelatedProfiles * 5);
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    const onRatingDetailsHandler = (objShortlistProfile: RelatedProfilesRequestModel, hasAccess: boolean) => {
        if (!hasAccess) {
            modalUtils.showLoader();
            addProfilesService.interviewRatingDetails(objShortlistProfile.interviewId).then((res) => {
                modalUtils.closeModal();
                if (!res.isSuccess || res.errorMessages.length > 0) {
                    toasterUtils.showError(res.errorMessages.toString());
                    return;
                }
                const config: GeneralPoupConfig = {
                    title: "Feedback Report",
                    content: (
                        <RatingDetailsPopUp
                            objRatingDetails={res.data} />
                    ),
                    size: ModalSize.XL,
                    className: "model-rating-details-badge"
                };
                modalUtils.showPopup(config);
            }).catch((error) => {
                modalUtils.closeModal();
                toasterUtils.showError("Erorr fetching Schedules");
            });
        } else {
            setRefreshRelatedProfiles(2);
            modalUtils.showLoader();
            relatedShortlistedProfilesService.saveCandidateAccessToViewProfile(objShortlistProfile).then((res) => {
                modalUtils.closeModal();
                if (!res.isSuccess || res.errorMessages.length > 0) {
                    toasterUtils.showError(res.errorMessages.toString());
                    return;
                }
                toasterUtils.showSuccess(res.informationMessages.toString());
                getRelatedProfiles(getSearchFilters(page, pageSize, sortColumn, sortDirection));
            }).catch((error) => {
                setRefreshRelatedProfiles(refreshRelatedProfiles * 5);
                modalUtils.closeModal();
                toasterUtils.showError(error);
            });
        }
    };

    const onPageChangeActionHandler = (newPage: number) => {
        setPage(newPage);
        getRelatedProfiles(getSearchFilters(newPage, pageSize, sortColumn, sortDirection));
    };

    const onPageSizeChangeActionHandler = (newPageSize: number) => {
        setPageSize(newPageSize);
        setPage(PagingEnum.page);
        getRelatedProfiles(getSearchFilters(PagingEnum.page, newPageSize, sortColumn, sortDirection));
    };

    return (
        <div className="card card-white">
            <div className="card-body">
                <div className="apply-filter">
                    Filter Candidates <i className="fas fa-filter" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight"></i>
                </div>
                <div className="offcanvas offcanvas-end" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
                    <div className="offcanvas-header">
                        <h5 className="offcanvas-title" id="offcanvasRightLabel">Apply Filter</h5>
                        <a type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></a>
                    </div>
                    <div className="offcanvas-body">
                        <div className="row">
                            <div>
                                <FormControl fullWidth margin="normal">
                                    <InputLabel>Total Rating</InputLabel>
                                    <Select value={totalRatingSearch} onChange={(e) => setTotalRatingSearch(parseInt(e.target.value as string))} label="Total Rating" size="small">
                                        <MenuItem value={0}>All</MenuItem>
                                        {props.ratingList.map((item, index) => (
                                            <MenuItem key={index} value={item.id}>
                                                {item.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                            <div>
                                <FormControl fullWidth margin="normal">
                                    <Autocomplete options={props.cityList} value={props.cityList.find((x) => x.id === citySearch) || null}
                                        onChange={(_, newValue) => setCitySearch(newValue ? newValue.id : 0)} getOptionLabel={(option) => option?.name || ""} isOptionEqualToValue={(option, value) => option.id === value.id}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Location" size="small" margin="normal" fullWidth />
                                        )}
                                    />
                                </FormControl>
                            </div>
                            <div>
                                <FormControl fullWidth margin="normal">
                                    <Autocomplete options={props.experienceList} value={props.experienceList.find((x) => x.id === experienceSearch) || null}
                                        onChange={(_, newValue) => setExperienceSearch(newValue ? newValue.id : 0)} getOptionLabel={(option) => option?.name || ""} isOptionEqualToValue={(option, value) => option.id === value.id}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Experience" size="small" margin="normal" fullWidth />
                                        )}
                                    />
                                </FormControl>
                            </div>
                            <div className="text-center">
                                <Button variant="contained" color="primary" type="submit"
                                    onClick={() => getRelatedProfiles(getSearchFilters(page, pageSize, sortColumn, sortDirection))} startIcon={<SearchIcon />}>
                                    Search
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                {refreshRelatedProfiles > 2 &&
                    <RelatedProfilesGridComponent
                        key={refreshRelatedProfiles}
                        relatedProfilesList={relatedProfilesList}
                        requirementId={props.requirementId}
                        totalSize={relatedProfilesPagedList?.totalCount ? relatedProfilesPagedList?.totalCount : relatedProfilesList.length}
                        currentPage={page + 1}
                        pagesize={pageSize}
                        sortColumn={sortColumn}
                        sortDirection={sortDirection === SortDirection.Asc ? "asc" : "desc"}
                        pageSizesList={pageSizesList}
                        onShortlistProfile={onShortlistProfileHandler}
                        onRatingDetails={onRatingDetailsHandler}
                        onPageChangeAction={onPageChangeActionHandler}
                        onPageSizeChangeAction={onPageSizeChangeActionHandler} />
                }
            </div>
        </div>
    );
};
export default RelatedProfilesComponent;